import { useState, useContext } from 'react';
import { useFirestoreOrderBy, useFirestore } from '../../firebase/useFirestore';
import Face4OutlinedIcon from "@mui/icons-material/Face4Outlined";
import { DeccaContext } from "../../StateManagment/DeccaContext.js";
import newConversation from "../../agents/newConversation.js";
import { Auth } from '../../StateManagment/Auth';
import { db, timestamp } from '../../firebase/config';
import { client } from "../../hooks/Client";
import uuid from 'react-uuid';
import Location from "../../hooks/Location";

const AITargetgroupAnalysis = () => {
    // Context
    const [auth] = useContext(Auth)
    const {
        chatOpen,
        setChatOpen,
        setSelectedConversationID,
        setShowConversations,
        setSubject,
        setContextData
        } = useContext(DeccaContext);

    // State
    const [selectedTargetgroupId, setSelectedTargetgroupId] = useState('');
    const [targetgroupTitle, setTargetgroupTitle] = useState('');

    // Hooks
    const pageName = Location()[2];

    // Firestore
    const allTargetgroups = useFirestore('Stakeholders');
    const conversations = useFirestoreOrderBy('Conversations', 'Position', 'desc');

    // Function to handle analysis with Decca
    const analysisHandler = async () => {
        const conversationID = uuid();
        const title = `Gesprek over ${pageName}`;
        const message = `<h2>Hallo ${auth.ForName}</h2><p>Zal ik een algemene analyse doen voor deze doelgroep ${targetgroupTitle} of wil je iets specifiekers weten?</p>`
        setSubject('AITargetgroupAnalysis');
        setContextData({
            targetgroupId: selectedTargetgroupId,
            targetgroupTitle: targetgroupTitle
        })
        setChatOpen(chatOpen === false ? true : true);
        await newConversation(
            conversationID, 
            title, 
            message,
            conversations.length + 1,
            client,
            timestamp,
            uuid(),
            auth.ID,
            auth.ForName,
            db
        );
        setSelectedConversationID(conversationID);
        setShowConversations(false);
    }

    // Select activity
    const selectTargetgroup = (e) => {
        const id = e.target.options[e.target.selectedIndex].value;
        const title = e.target.options[e.target.selectedIndex].dataset.title;

        setSelectedTargetgroupId(id);
        setTargetgroupTitle(title);
    }
        
  return (
    <div className='insights-main-type-container dashboard-container'>
        <h2>AI doelgroep analyse</h2>
        <p>Creeer een AI analyse van een specifieke doelgroep.</p>
        <p><b>Selecteer doelgroep</b></p>
        <select name="" id="" onChange={selectTargetgroup}>
            <option value="" >-- Selecteer doelgroep --</option>
            {allTargetgroups && allTargetgroups.map(targetgroup => (
                <option value={targetgroup.ID} data-title={targetgroup.Organisation}>{targetgroup.Organisation}</option>
            ))}
        </select>
        <div id='page-header-impact-ai-container' className="analysis-ai-container" onClick={analysisHandler}>
            <div id='page-header-impact-ai-inner-container'>
                <Face4OutlinedIcon/>
                <p>Analyseer met Decca</p>
            </div>
        </div>
    </div>
  )
}

export default AITargetgroupAnalysis